import React from 'react';
import CommentBox from './comment-box';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { generateLocalCommentId } from '../comment-list/id-utils';
import { COMMENT_BOX_TOP, COMMENT_BOX_BOTTOM } from '../../../common/constants/data-hooks';
import throttle from 'lodash/throttle';
import { useRootBoxEffect } from '../../context/root-box-effect-context/use-root-box-effect';
import { useTranslate } from '../../context/api-context/translations/use-translate';
const RootCommentBox = ({ className, position, shoudDispatchIAmTyping, withGuestFlow, canRate, boxRating }) => {
    const { resourceId, ctxFields, ratings } = useConfiguration();
    const t = useTranslate();
    const { createComment, biDiscardComment, iAmTyping, setInputRating } = useApi((state, actions) => {
        return {
            createComment: actions.createComment,
            biDiscardComment: actions.biDiscardComment,
            iAmTyping: actions.iAmTyping,
            setInputRating: actions.setInputRating,
        };
    });
    const ref = React.useRef(null);
    const rootBoxEffect = useRootBoxEffect();
    React.useEffect(() => {
        if (ref.current) {
            rootBoxEffect.optIn({ position, box: ref.current });
            return () => rootBoxEffect.optOut(position);
        }
    }, [rootBoxEffect, position]);
    const iAmTypingThrottled = React.useMemo(() => throttle(() => iAmTyping({ resourceId }), 3000, { leading: true, trailing: false }), [resourceId, iAmTyping]);
    return (React.createElement(CommentBox, { forwardRef: ref, id: `root-comment-box-${position}-${resourceId}`, className: className, dataHook: position === 'start' ? COMMENT_BOX_TOP : COMMENT_BOX_BOTTOM, isEdit: false, isReply: false, isInList: false, formName: `comment-${position}`, onTyping: shoudDispatchIAmTyping ? iAmTypingThrottled : undefined, withGuestFlow: withGuestFlow, onSubmit: ({ content, rating, email, authorName }, reset, asGuest) => {
            createComment({
                localId: generateLocalCommentId(),
                content,
                resourceId,
                ctxFields,
                position,
                asGuest: asGuest,
                rating,
                email,
                authorName,
            });
            reset();
        }, onCancel: (_content, reset, isEmpty) => isEmpty
            ? { type: 'SILENT_CANCEL', cleanup: reset }
            : {
                type: 'PROMPT',
                discard: 'COMMENT',
                onConfirm: () => {
                    reset();
                    biDiscardComment({ type: 'comment', resourceId });
                },
            }, rating: ratings && {
            value: boxRating.value,
            isRequired: !!ratings.isRequired,
            hasPrevious: boxRating.hasPrevious,
        }, ratingLabel: ratings
            ? ratings.addRatingText
                ? ratings.addRatingText
                : t(boxRating.hasPrevious ? 'comment-box.update-rating' : 'comment-box.add-a-rating')
            : undefined, onRatingChange: canRate && !boxRating.isPending
            ? (rating) => setInputRating({ resourceId, rating })
            : undefined }));
};
export default RootCommentBox;
//# sourceMappingURL=root-comment-box.js.map